import { render } from "./UserDetailsView.vue?vue&type=template&id=80e04532&scoped=true&ts=true"
import script from "./UserDetailsView.vue?vue&type=script&lang=ts"
export * from "./UserDetailsView.vue?vue&type=script&lang=ts"

import "./UserDetailsView.vue?vue&type=style&index=0&id=80e04532&lang=scss&scoped=true"

import exportComponent from "/working_dir/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-80e04532"]])

export default __exports__